module.exports = __webpack_public_path__ + "media/svg/pf-18a00b3a.svg";